import React from 'react';

import { useTranslation } from 'react-i18next';

import EmptyBellAlertIcon from 'styles/assets/bellAlerts/emptyNotificationIcon.png';

import styles from './emptyBellAlertList.module.scss';

const EmptyBellAlertList = () => {
  const { t } = useTranslation(['common']);

  return (
    (<div className={styles.mainContainer} data-palette="EmptyBellAlertList">
      <div className={styles.contentBox}>
        <img src={EmptyBellAlertIcon} alt="Notifications" />
        <div className={styles.text}>{t('common:bellAlerts.caughtUp')}</div>
      </div>
    </div>)
  );
};

export default EmptyBellAlertList;
